module.exports = __webpack_public_path__ + "img/CUSTOMER-EXPERIENCE-thumb.cbf6ed58.png";